module.exports = __webpack_public_path__ + "media/images/focus-example-form-28447437a266063e223da441c74986c8.jpg";